"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "side-menu"
  }, [_c("div", {
    staticClass: "side-menu-template"
  }, [_c("div", {
    staticClass: "menu-header"
  }, [_vm._t("menu-header")], 2), _vm._v(" "), _c("div", {
    staticClass: "menu-button"
  }, [_vm._t("menu-button")], 2), _vm._v(" "), _c("div", {
    staticClass: "menu-options"
  }, [_vm._t("menu-options")], 2)])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;